export const locations = [
  { label: 'Gomti Nagar', slug: 'gomti-nagar' },
  { label: 'Mahanagar', slug: 'mahanagar' },
  { label: 'Aliganj', slug: 'aliganj' },
  { label: 'Indira Nagar', slug: 'indira-nagar' },
  { label: 'Aashiana', slug: 'aashiana' },
  { label: 'Alambagh', slug: 'alambagh' },
  { label: 'Alamnagar', slug: 'alamnagar' },
  { label: 'LDA Colony', slug: 'lda-colony' },
  { label: 'Charbagh', slug: 'charbagh' },
  { label: 'Aishbagh', slug: 'aishbagh' },
  { label: 'Vikas Khand', slug: 'vikas-khand' },
  { label: 'Omaxe City', slug: 'omaxe-city' },
  { label: 'Vigyan Khand', slug: 'vigyan-khand' },
  { label: 'Vishesh Khand', slug: 'vishesh-khand' },
  { label: 'Tedhi Puliya', slug: 'tedhi-puliya' },
  { label: 'Sadar Bazaar', slug: 'sadar-bazaar' },
  { label: 'Nakkhas', slug: 'nakkhas' },
  { label: 'Polytechnic Chauraha', slug: 'polytechnic-chauraha' },
  { label: 'Campbell Road', slug: 'campbell-road' },
  { label: 'Khadra', slug: 'khadra' },
  { label: 'Gomti Nagar Extension', slug: 'gomti-nagar-extension' },
  { label: 'Vibhuti Khand', slug: 'vibhuti-khand' },
  { label: 'Jankipuram', slug: 'jankipuram' },
  { label: 'Kalyanpur', slug: 'kalyanpur' },
  { label: 'Rajajipuram', slug: 'rajajipuram' },
  { label: 'Chinhat', slug: 'chinhat' },
  { label: 'Sarojini Nagar', slug: 'sarojini-nagar' },
].sort((a, b) => a.label.localeCompare(b.label));

export function slugToLabel(slug) {
  const found = locations.find((l) => l.slug === slug);
  return found ? found.label : slug.replace(/-/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase());
}

export function labelToSlug(label) {
  const found = locations.find((l) => l.label === label);
  return found ? found.slug : label.toLowerCase().replace(/\s+/g, '-');
}